import { type FC } from 'react';
import { Alert } from '@mantine/core';
import { IconFileUpload } from '@tabler/icons-react';
import styles from './ReceiptInstructions.module.css';

export const ReceiptInstructions: FC = () => {
    return (
        <Alert
            role='note'
            aria-label='Как передать чек'
            title='Как передать чек'
            icon={<IconFileUpload size={20} />}
            radius='lg'
            variant='light'
            bg='var(--app-accent-soft)'
            bd='1px solid var(--app-accent-border)'
            classNames={{
                icon: styles.icon,
                title: styles.title,
                message: styles.message,
            }}
        >
            Отправьте PDF на указанный ниже email или прикрепите его непосредственно в ордере со статусом «В работе»,
            предварительно открыв его.
        </Alert>
    );
};
